
  import { Vue, Prop, Component } from "vue-property-decorator";
  import { IAdsModel, ICategoryModel } from "@/models";
  import { Utils } from "@/helper";
  import dayjs from "dayjs";

  @Component({
    name: "PostListItem"
  })
  export default class PostListItem extends Vue {
    @Prop() item!: IAdsModel;
    @Prop({ default: "" }) searchText!: string;
    @Prop({ default: false }) isAllowedToEdit: boolean;
    @Prop({ default: false }) isAdmin: boolean;

    get isAllowedToExtend() {
      if (
        this.item.pendingAuthorization == false &&
        this.item.rejected == false
      )
        return this.isAllowedToEdit;
      return false;
    }
    getPostingDate(date: Date) {
      return dayjs(date).format("MM/DD/YYYY");
    }

    call(phoneNumber: string) {
      const phone = Utils.PhoneNumberFormated(phoneNumber);
      window.open(`tel:${phone}`);
    }
    getAdImage(id: number) {
      if (process.env.NODE_ENV === "development") {
        return `${process.env.VUE_APP_IMAGE_HANDLER}?docid=${id}`;
      }
      return `${window.location.origin}/${process.env.VUE_APP_IMAGE_HANDLER}?docid=${id}`;
    }

    getImageList():Array<number>{
      var pictureIds = new Array<number>();
      if(this.item.pictureId > 0){
        pictureIds.push(this.item.pictureId);
      }

      if(this.item.pictures){
        this.item.pictures.forEach(item => {
          pictureIds.push(item.pictureId);
        })
      }

      return pictureIds;
    }

    get publicPath(): string {
      return `${window.location.origin}${process.env.BASE_URL}`;
    }

    get highlight(): string {
      if (this.searchText.trim() === "") {
        return this.item.contents;
      }
      return this.item.contents.replace(
        new RegExp(this.searchText, "gi"),
        match => {
          return "<span class='highlightText'>" + match + "</span>";
        }
      );
    }
    get highlightTitle(): string {
      if (this.searchText.trim() === "") {
        return this.item.title;
      }
      return this.item.title.replace(
        new RegExp(this.searchText, "gi"),
        match => {
          return "<span class='highlightText'>" + match + "</span>";
        }
      );
    }
    get highlightName(): string {
      if (this.searchText.trim() === "") {
        return this.item.name;
      }
      return this.item.name.replace(
        new RegExp(this.searchText, "gi"),
        match => {
          return "<span class='highlightText'>" + match + "</span>";
        }
      );
    }

    get highlightPhone(): string {
      const phone = this.phoneNumberFormated(this.item.phone);

      if (this.searchText.trim() === "") {
        return phone;
      }

      return phone.replace(new RegExp(this.searchText, "gi"), match => {
        return "<span class='highlightText'>" + match + "</span>";
      });
    }

    clipboardSuccessHandler(e: any) {
      this.$modal.show("Ad url was copied to clipboard", "success");
    }
    parentCategory(parentCategory: ICategoryModel) {
      return (
        (parentCategory === null ? "Category" : `${parentCategory.category}`) +
        " - "
      );
    }
    phoneNumberFormated(phone: string): string {
      return Utils.PhoneNumberFormated(phone);
    }
  }
